// 权益券核销记录 Mock（对齐数据库权益券模块的核销记录表）
// 界面不暴露表名/字段名
//
// 核销链路：核销员扫用户券上的核销码 → 校验券码与状态 → 记一条记录。
// 无论成功失败都留痕（失败原因：已核销 / 已过期 / 券码无效）。

import { USER_BENEFIT_LIST } from './userBenefit'

export const VERIFY_RESULT = [
  { label: '核销成功', value: 1 },
  { label: '核销失败', value: 0 }
]

export const FAIL_REASONS = ['券码已核销', '券码已过期', '券码已作废', '券码无效']

export function verifyResultText(result) {
  const hit = VERIFY_RESULT.find(r => r.value === result)
  return hit ? hit.label : '未知'
}

export function verifyResultTagType(result) {
  return result === 1 ? 'success' : 'danger'
}

export const VERIFY_LOG_LIST = [
  {
    id: 7001, user_benefit_id: 9002, user_id: 102, nickname: '桂林山水甲天下', benefit_name: '圣山塔林景区畅游券',
    verify_code: '357194806312', result: 1, fail_reason: '',
    operator_name: '莫接待', verify_time: '2026-09-06 09:24:37'
  },
  {
    id: 7002, user_benefit_id: 9006, user_id: 108, nickname: '稻香人家', benefit_name: '圣山塔林景区畅游券',
    verify_code: '240861597733', result: 1, fail_reason: '',
    operator_name: '莫接待', verify_time: '2026-09-09 10:11:26'
  },
  {
    id: 7003, user_benefit_id: 9005, user_id: 106, nickname: '塔林常客·老周', benefit_name: '桂林3日旅居权益券',
    verify_code: '773920461558', result: 1, fail_reason: '',
    operator_name: '黄总', verify_time: '2026-06-18 15:40:09'
  },
  {
    id: 7004, user_benefit_id: 9011, user_id: 114, nickname: '远山淡影', benefit_name: '圣山塔林景区畅游券',
    verify_code: '703148625579', result: 1, fail_reason: '',
    operator_name: '李经理', verify_time: '2026-08-30 13:02:47'
  },
  {
    id: 7005, user_benefit_id: 9014, user_id: 105, nickname: '梅子黄时雨', benefit_name: '桂林3日旅居权益券',
    verify_code: '954120387615', result: 1, fail_reason: '',
    operator_name: '黄总', verify_time: '2026-07-04 09:35:12'
  },
  {
    id: 7006, user_benefit_id: 9002, user_id: 102, nickname: '桂林山水甲天下', benefit_name: '圣山塔林景区畅游券',
    verify_code: '357194806312', result: 0, fail_reason: '券码已核销',
    operator_name: '莫接待', verify_time: '2026-09-06 09:31:58'
  },
  {
    id: 7007, user_benefit_id: 9003, user_id: 103, nickname: '清风入竹', benefit_name: '家脉通用消费券',
    verify_code: '902384715620', result: 0, fail_reason: '券码已过期',
    operator_name: '林运营', verify_time: '2026-09-11 10:06:22'
  },
  {
    id: 7008, user_benefit_id: 0, user_id: 0, nickname: '未知用户', benefit_name: '—',
    verify_code: '100293847561', result: 0, fail_reason: '券码无效',
    operator_name: '莫接待', verify_time: '2026-09-08 16:44:03'
  },
  {
    id: 7009, user_benefit_id: 9008, user_id: 110, nickname: '小满未满', benefit_name: '春分祭祖活动券',
    verify_code: '639058214477', result: 0, fail_reason: '券码已过期',
    operator_name: '李经理', verify_time: '2026-04-18 10:15:00'
  },
  {
    id: 7010, user_benefit_id: 9001, user_id: 101, nickname: '塔塔得旅行日记', benefit_name: '桂林3日旅居权益券',
    verify_code: '684219375206', result: 1, fail_reason: '',
    operator_name: '黄总', verify_time: '2026-09-10 14:52:31'
  }
]

// ---------- 核销操作 ----------

function pad(n) { return n < 10 ? '0' + n : '' + n }

export function nowText() {
  const d = new Date()
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
    + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

// 归一化核销码：去空格、转大写（券码含字母时大小写不敏感）
export function normalizeCode(code) {
  return String(code || '').replace(/\s/g, '').toUpperCase()
}

// 按核销码查用户券
export function findUserBenefit(code) {
  const c = normalizeCode(code)
  if (!c) return null
  return USER_BENEFIT_LIST.find(x => String(x.verify_code).toUpperCase() === c) || null
}

let verifySeq = 7100

// 核销一张券：校验 → 改券状态 → 写一条记录（成功失败都写）
// 返回 { result, fail_reason, record, target }
export function verifyByCode(code, operatorName) {
  const c = normalizeCode(code)
  const time = nowText()
  let target = null
  let result = 1
  let failReason = ''

  if (!c) {
    result = 0
    failReason = '券码无效'
  } else {
    target = findUserBenefit(c)
    if (!target) {
      result = 0
      failReason = '券码无效'
    } else if (target.status === 1) {
      result = 0
      failReason = '券码已核销'
    } else if (target.status === 3) {
      result = 0
      failReason = '券码已作废'
    } else if (target.status === 2 || (target.expire_time && target.expire_time < time)) {
      result = 0
      failReason = '券码已过期'
      target.status = 2
    } else {
      target.status = 1
      target.use_time = time
    }
  }

  verifySeq += 1
  const record = {
    id: verifySeq,
    user_benefit_id: target ? target.id : 0,
    user_id: target ? target.user_id : 0,
    nickname: target ? target.nickname : '未知用户',
    benefit_name: target ? target.benefit_name : '—',
    verify_code: c,
    result,
    fail_reason: failReason,
    operator_name: operatorName || '当前管理员',
    verify_time: time
  }
  VERIFY_LOG_LIST.unshift(record)
  return { result, fail_reason: failReason, record, target }
}

// 作废一张券：未使用 → 已作废（status 3），此后无法核销，不可恢复
// 返回 { result, message, target }；result=0 时 message 为不可作废的原因
export function voidByCode(code) {
  const target = findUserBenefit(code)
  if (!target) return { result: 0, message: '未查询到该核销码，请确认是否输错', target: null }
  if (target.status === 1) return { result: 0, message: '该券已核销，无法作废', target }
  if (target.status === 2) return { result: 0, message: '该券已过期，无需作废', target }
  if (target.status === 3) return { result: 0, message: '该券已作废，请勿重复操作', target }
  target.status = 3
  return { result: 1, message: '', target }
}

// 今日核销统计
export function todayStats() {
  const day = nowText().slice(0, 10)
  const today = VERIFY_LOG_LIST.filter(x => (x.verify_time || '').slice(0, 10) === day)
  return {
    success: today.filter(x => x.result === 1).length,
    fail: today.filter(x => x.result === 0).length
  }
}
